import { useId } from 'react';
import { Dialog } from '@240tutoring/labs-ui/dialog';

/** Deleting a plan is permanent, so it is asked first (R10, R18). */
export function ConfirmDelete({ name, busy = false, error, onConfirm, onCancel }: {
  name: string; busy?: boolean; error?: string | null; onConfirm(): void; onCancel(): void;
}) {
  const titleId = useId();
  return <Dialog titleId={titleId} onClose={() => { if (!busy) onCancel(); }} className="delete-dialog">
    <h2 id={titleId}>Delete this plan?</h2>
    <p><strong>{name}</strong> and every unit in it will be removed for good. This cannot be undone.</p>
    {error && <p className="error-message" role="alert">{error}</p>}
    <div className="dialog-actions">
      <button className="secondary" type="button" onClick={onCancel} disabled={busy} autoFocus>Cancel</button>
      <button className="primary destructive" type="button" onClick={onConfirm} disabled={busy}>{busy ? 'Deleting…' : 'Delete plan'}</button>
    </div>
  </Dialog>;
}
